import React from 'react';
import { Link } from 'react-router-dom';
import { useImages } from '../context/ImageContext';
import Footer from '../components/Footer';

const LifeAlertComparedToAlert1Page: React.FC = () => {
  const { getImage } = useImages();

  const coupleCookingImage = getImage('couple-cooking.webp');
  const facebookImage = getImage('facebook-image-1.png');
  const womanBikeImage = getImage('woman-bike.webp');

  return (
    <div className="life-alert-compared-to-alert1-page">
      {/* Hero Section */}
      <section className="compare-hero-new" style={{ padding: '2rem 1rem' }}>
        <div className="compare-hero-container" style={{ maxWidth: '1000px', margin: '0 auto', display: 'flex', alignItems: 'center', gap: '2rem' }}>
          <div className="compare-hero-content" style={{ flex: 1, paddingBottom: '0' }}>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '1rem', color: '#333', lineHeight: '1.2' }}>
              Life Alert Cost Guide<br />
              (2025):<br />
              Pricing and Alternatives
            </h1>
            
            <p className="compare-hero-text" style={{ fontSize: '1rem', lineHeight: '1.6', color: '#444', marginTop: '1rem', marginBottom: '0' }}>
              Alert1 medical alert systems provide the same great features and service as Life Alert and MORE, but at a fraction of the cost!<sup>1</sup> If you are seeking the best value for a personal emergency alert device with a 24/7/365 response team, the clear choice is Alert1.
            </p>
          </div>
          
          <div className="compare-hero-image" style={{ flexShrink: 0 }}>
            <div className="circular-image-wrapper" style={{ width: '350px', height: '350px' }}>
              {coupleCookingImage ? (
                <img 
                  src={coupleCookingImage} 
                  alt="Senior couple cooking together" 
                  className="circular-image"
                />
              ) : (
                <div className="circular-image-placeholder" />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Table Section */}
      <section className="comparison-section" style={{ padding: '3rem 2rem', background: '#f9f9f9' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#333', textAlign: 'center' }}>
            Alert1 vs Life Alert Cost At a Glance
          </h2>
          <p className="section-subtitle" style={{ fontSize: '1.1rem', color: '#666', textAlign: 'center', marginBottom: '2rem' }}>
            Our Members Prefer Alert1&rsquo;s Service and Affordability
          </p>
          
          <div className="comparison-table-wrapper">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th></th>
                  <th className="highlight-col">Alert1</th>
                  <th>Life Alert</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Monthly Fee Starting At</strong></td>
                  <td className="highlight-col">$19.95</td>
                  <td>$69.90</td>
                </tr>
                <tr>
                  <td><strong>Activation Fee</strong></td>
                  <td className="highlight-col">$0.00</td>
                  <td>$0.00-$95.00</td>
                </tr>
                <tr>
                  <td><strong>Length of Agreement</strong></td>
                  <td className="highlight-col">1 month-1 year</td>
                  <td>3 years</td>
                </tr>
                <tr>
                  <td><strong>Stay on the Line Until Help Arrives</strong></td>
                  <td className="highlight-col">YES</td>
                  <td>NO</td>
                </tr>
                <tr>
                  <td><strong>Pricing & Terms Posted Online</strong></td>
                  <td className="highlight-col">YES</td>
                  <td>NO</td>
                </tr>
                <tr>
                  <td><strong>Easy to Order Online</strong></td>
                  <td className="highlight-col">YES</td>
                  <td>NO</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="table-footnote" style={{ marginTop: '2rem', fontSize: '0.9rem', color: '#666', lineHeight: '1.6' }}>
            <p>
              <sup>1</sup>Disclaimer: All information, prices, and data was last verified in September 2024. To report any incorrect or outdated information, please get in touch with us. For more information on Alert1&rsquo;s features and costs, check out our <Link to="/pricing" style={{ color: '#0066cc', textDecoration: 'underline' }}>pricing page</Link>. To compare Alert1 to other medical alert systems, visit our <Link to="/pricing/compare-medical-alert-systems" style={{ color: '#0066cc', textDecoration: 'underline' }}>Comparison Hub</Link>.
            </p>
          </div>
        </div>
      </section>

      {/* You're in Good Company Section */}
      <section style={{ padding: '3rem 2rem', background: 'white' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem', color: '#333' }}>
            You&rsquo;re in good company
          </h2>
          <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '2rem' }}>
            More than 234,000 families nationwide have relied on Alert1 to stay safe and live better
          </p>
          
          {facebookImage && (
            <div style={{ marginTop: '2rem' }}>
              <img 
                src={facebookImage} 
                alt="Alert1 customer testimonials" 
                style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
              />
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ padding: '3rem 2rem', background: 'white' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5rem' }}>
          <div style={{ flexShrink: 0 }}>
            {womanBikeImage && (
              <div className="circular-image-wrapper" style={{ width: '400px', height: '400px' }}>
                <img 
                  src={womanBikeImage} 
                  alt="Active senior with Alert1" 
                  className="circular-image"
                />
              </div>
            )}
          </div>
          
          <div style={{ maxWidth: '500px', textAlign: 'left' }}>
            <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1.5rem', color: '#333', lineHeight: '1.3' }}>
              Don&rsquo;t pay more for<br />
              Life Alert.<br />
              Experience the<br />
              Alert1 difference!
            </h2>
            
            <div style={{ marginTop: '2rem' }}>
              <Link 
                to="/medical-alerts" 
                className="btn btn-primary" 
                style={{ 
                  display: 'inline-block',
                  padding: '1rem 2rem',
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  backgroundColor: '#c8102e',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '6px',
                  textAlign: 'center'
                }}
              >
                SAVE MONEY NOW
              </Link>
            </div>
            
            <p style={{ marginTop: '2rem', fontSize: '1rem', color: '#666', lineHeight: '1.6' }}>
              Or call us for a complimentary<br />
              consultation: <strong>877-573-4195</strong>
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LifeAlertComparedToAlert1Page;
